/** Human labels + OSINT site: targets (keyless brand monitoring). */

export const SOURCE_LABELS: Record<string, string> = {
  serp: "Поиск",
  wb: "Wildberries",
  ozon: "Ozon",
  avito: "Avito",
  ymarket: "Яндекс Маркет",
  aliexpress: "AliExpress",
  vk: "ВКонтакте",
  youla: "Юла",
  youtube: "YouTube",
  tiktok: "TikTok",
  telegram: "Telegram",
  rutube: "Rutube",
  dzen: "Дзен",
  instagram: "Instagram",
  alerts: "Google Alerts",
  image: "Похожие фото",
  demo: "Demo",
};

/** Marketplaces / classifieds — prefer direct collectors. */
export const MARKET_SOURCES = [
  "wb",
  "ozon",
  "avito",
  "ymarket",
  "aliexpress",
  "vk",
  "youla",
] as const;

/**
 * OSINT surface: indexed pages via SERP `site:`.
 * No official APIs — works without keys; coverage = what search engines see.
 */
export const OSINT_SITE_SOURCES: Record<
  string,
  { site: string; label: string; defaultOn?: boolean }
> = {
  youtube: { site: "youtube.com", label: "YouTube", defaultOn: true },
  tiktok: { site: "tiktok.com", label: "TikTok", defaultOn: true },
  telegram: { site: "t.me", label: "Telegram", defaultOn: true },
  rutube: { site: "rutube.ru", label: "Rutube", defaultOn: true },
  dzen: { site: "dzen.ru", label: "Дзен", defaultOn: true },
  instagram: { site: "instagram.com", label: "Instagram", defaultOn: false },
};

export const DEFAULT_OSINT_SOURCES = Object.entries(OSINT_SITE_SOURCES)
  .filter(([, v]) => v.defaultOn !== false)
  .map(([id]) => id);
